import { ErrorCodes } from './error-codes.js';
import { dataResponse, deleteResponse, errorCodeResponse, errorResponse } from './utils/response-templates.js';
import { z } from './utils/zod.js';
export const fontInstructionSchema = z.object({
    // Frontend WASM-side font pointer. Backend ignores this; it's only
    // kept on the payload so the frontend can de-dupe and join with its
    // own per-handle metadata.
    pdfiumFontHandle: z.number(),
    // Exact ASCII string in the saved PDF's font dictionary
    // (FPDFFont_GetBaseFontName). The backend uses this to find the
    // matching font dict and overwrite its descriptor entries with a
    // fully embedded Google Font for the same family/weight/italic.
    subsetBaseFontName: z.string(),
    googleFamily: z.string(),
    googleWeight: z.number(),
    googleItalic: z.boolean(),
});
export const uploadDocumentRequestSchema = z.object({
    file: z.instanceof(File),
    // JSON-encoded `FontInstruction[]`. When present, the frontend bake
    // produced a PDF whose inserted glyphs reference subset fonts that
    // don't cover those glyphs; the backend embeds the matching Google
    // Fonts and rewrites the font references so the saved PDF renders
    // every character. Optional — old clients and unedited uploads
    // simply omit it.
    fontInstructions: z.string().optional(),
});
export const allowedTypesEnum = z.enum([
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
]);
export const documentConversionStatusSchema = z.enum(['PENDING', 'CONVERTING', 'READY', 'FAILED']);
export const documentDtoSchema = z.object({
    id: z.string(),
    filename: z.string(),
    byteSize: z.string(),
    pageCount: z.number(),
    hasExistingSignature: z.boolean(),
    conversionStatus: documentConversionStatusSchema,
});
export const createDocumentResponseSchema = dataResponse(documentDtoSchema);
export const uploadDocumentResponseSchema = dataResponse(documentDtoSchema);
export const documentInvalidFileResponseSchema = errorResponse('Invalid file');
export const documentMaxLimitErrorResponseSchema = errorCodeResponse(ErrorCodes.EOrganizationLimit, 'Max documents reached for your organization');
export const documentStatusResponseSchema = dataResponse(z.object({
    conversionStatus: documentConversionStatusSchema,
    pageCount: z.number(),
    filename: z.string(),
}));
export const deleteDocumentResponseSchema = deleteResponse();
export var DocumentPurpose;
(function (DocumentPurpose) {
    DocumentPurpose["Download"] = "download";
    DocumentPurpose["View"] = "view";
})(DocumentPurpose || (DocumentPurpose = {}));
